import styled from 'styled-components';

export const Container = styled.div`
    width: 95%;
    min-height: calc(90% - 60px);
    background: #ffffff;
    margin: 30px auto 100px auto;
    border-radius: 5px;
`;

export const InfoCardTables = styled.div`
    width: 100%;
    height: 90%;
    display: flex;
    flex-direction: column;
    align-items: space-center;
    justify-content: space-between;
`;

export const InfoCard = styled.div`
    /* background: #FCFCFC; */
    background: white;
    padding: 10px 10px 20px 10px;
    border-radius: 1px;
    border: 1px solid #DFDFDF;
    width: 20%;
    min-width: 265px;
    height: 21vw;
    min-height: 270px;
    margin: 30px auto 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; 
`

export const TablesCard = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0 4.9% 20px 4.9%;
    margin: 20px 0;
    flex-wrap: wrap;
`

export const DateInputs = styled.div`
    width: 20%;
    min-width: 280px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: unset;
`

export const Navbar = styled.div`
    width: 100%;
    height: 50px;
    padding: 0 6%;
    background: unset;
    display: flex;
    align-items: center;
    justify-content: left;
    border-bottom: #E3E3E3 1px solid;
`

export const Total = styled.div`
    width: 13%;
    min-width: 185px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: unset;
    margin-left: 2.4%;
`

export const InfoNonTables = styled.div`
    width: 100%;
    padding: 0 5%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
`